var exports = {
  "k": "container__xpkYqE",
};

module.exports = exports;
